import axios from "axios";

class SearchExam {
  // 1. describe and create/initiate our object
  constructor() {
    this.resultsDiv = document.querySelector("#exam__results");
    this.searchOverlay = document.querySelector(".search-overlay");

    // Check if the "languages" element is available
    if (document.getElementById("languages")) {
      this.searchField = document.getElementById("languages");
    }

    // Check if the "types" element is available
    if (document.getElementById("types")) {
      this.searchField2 = document.getElementById("types");
    }

    // Check if the "levels" element is available
    if (document.getElementById("levels")) {
      this.searchField3 = document.getElementById("levels");
    }

    // Check if the "examform" element is available
    if (document.getElementById("examform")) {
      this.searchField4 = document.getElementById("examform");
    }
    this.isOverlayOpen = false;
    this.isSpinnerVisible = false;
    this.previousValue;
    this.previousValue2;
    this.previousValue3;
    this.previousValue4;
    this.typingTimer;
    this.events();
  }

  // 2. events
  events() {
    if (document.getElementById("languages")) {
      this.searchField.addEventListener("change", () => this.typingLogic());
      if (this.searchField2) {
        this.searchField2.addEventListener("change", () => this.typingLogic());
      }
      this.searchField3.addEventListener("change", () => this.typingLogic());

      if (this.searchField4) {
        this.searchField4.addEventListener("change", () => this.typingLogic());
      }
    }
  }

  // 3. methods (function, action...)
  typingLogic() {
    // console.log("running");
    console.log(this.searchField.value);
    if (this.searchField2.value) {
      console.log(this.searchField2.value);
    }
    if (this.searchField2.value) {
      console.log(this.searchField2.value);
    }
    if (this.searchField2.value) {
      console.log(this.searchField2.value);
    }

    if (
      this.searchField.value != this.previousValue ||
      this.searchField2.value != this.previousValue2 ||
      this.searchField3.value != this.previousValue3 ||
      this.searchField4.value != this.previousValue4
    ) {
      clearTimeout(this.typingTimer);

      if (this.searchField.value || this.searchField2.value || this.searchField3.value || this.searchField4.value) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.innerHTML = '<div class="spinner-loader"></div>';
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750);
      } else {
        this.resultsDiv.innerHTML = "";
        this.isSpinnerVisible = false;
      }
    }

    this.previousValue = this.searchField.value;
    this.previousValue2 = this.searchField2.value;
    this.previousValue3 = this.searchField3.value;
    this.previousValue4 = this.searchField4.value;
  }

  async getResults() {
    try {
      let url = universityData.root_url + "/";

      // if (window.location.href == url) {
      //   console.log("True");
      // }

      const searchRouteUrl =
        window.location.href.includes("/vizsgaidopontok-es-dijak/") ||
        window.location.href === url ||
        window.location.href.includes("/nyelvvizsga/")
          ? "/wp-json/university/v1/search?term="
          : "/wp-json/university/v3/search?term=";
      //console.log(window.location.href);
      //console.log(window.location.href);
      //console.log(searchRouteUrl);
      let searchQuery =
        this.searchField.value +
        " " +
        this.searchField2.value +
        " " +
        this.searchField3.value +
        " " +
        this.searchField4.value;
      if (window.location.href.includes("junior")) {
        searchQuery += " junior";
      }

      const response = await axios.get(universityData.root_url + searchRouteUrl + searchQuery);

      //console.log(searchQuery);
      const results = response.data;
      console.log(results);
      if (
        window.location.href.includes("/vizsgaidopontok-es-dijak/") ||
        window.location.href === url ||
        window.location.href.includes("/nyelvvizsga/")
      ) {
        this.resultsDiv.innerHTML = `
        
          <div class="one-full">
            

            <h2 class="search-overlay__section-title">Vizsgák</h2>
            ${results.events.length ? "" : `<p>Nem találtunk ilyen vizsgát. </p>`}
              ${results.events
                .map(
                  (item) => `
                <div class="event-summary">
                  <a class="event-summary__date t-center" href="${item.permalink}">
                    <span class="event-summary__month">${item.month}</span>
                    <span class="event-summary__day">${item.day}</span>  
                  </a>
                  <div class="event-summary__content">
                    <h5 class="event-summary__title headline headline--tiny"><a href="${item.permalink}">${item.title}</a></h5>
                    
                  </div>
                </div>
              `
                )
                .join("")}

          </div>
        </div>
      `;
      }
      if (window.location.href.includes("/minta-es-gyakorlofeladatok/")) {
        this.resultsDiv.innerHTML = `
        
          <div class="one-full m-2">

          <h2 class="search-overlay__section-title">Mintafeladatok</h2>
          ${results.mintafeladatok.length ? "" : `<p>Nem találtunk ilyen feladatot.</p>`}
            ${results.mintafeladatok
              .map(
                (item) => `
              <div class="feladat-summary">
                
                <div class="event-summary__content">
                  <h5 class="feladat-summary__title headline headline--tiny">${item.title}</h5>
                  <p class="feladat-summary__content headline headline--tiny"></p>
                  ${
                    item.link
                      ? `<button class="btn-secondary bg-blue pill white mb-2"><a target="_blank" href="${item.link}" class="nu white">Feladatok</a></button>`
                      : ""
                  }
                      ${
                        item.link2
                          ? `<button class="btn-secondary bg-blue pill white mb-2"><a target="_blank" href="${item.link2}" class="nu white">Megoldások</a></button>`
                          : ""
                      }
                      ${
                        item.link3
                          ? `<button class="btn-secondary bg-blue pill white mb-2"><a target="_blank" href="${item.link3}" class="nu white">Hanganyag</a></button>`
                          : ""
                      }
                </div>
              </div>
              
            `
              )
              .join("")}

          </div>

          <div class="one-full m-2">

          <h2 class="search-overlay__section-title">Gyakorlófeladatok</h2>
          ${results.gyakorlofeladatok.length ? "" : `<p>Nem találtunk ilyen feladatot.</p>`}
            ${results.gyakorlofeladatok
              .map(
                (item) => `
              <div class="feladat-summary">
                
                <div class="event-summary__content">
                  <h5 class="feladat-summary__title headline headline--tiny">${item.title}</h5>
                  <p class="feladat-summary__title headline headline--tiny"></p>
                  ${
                    item.link
                      ? `<button class="btn-secondary bg-blue pill white mb-2"><a target="_blank" href="${item.link}" class="nu white">Feladatok</a></button>`
                      : ""
                  }
                      ${
                        item.link2
                          ? `<button class="btn-secondary bg-blue pill white mb-2"><a target="_blank" href="${item.link2}" class="nu white">Megoldások</a></button>`
                          : ""
                      }
                      ${
                        item.link3
                          ? `<button class="btn-secondary bg-blue pill white mb-2"><a target="_blank" href="${item.link3}" class="nu white">Hanganyag</a></button>`
                          : ""
                      }
                </div>
              </div>
              
            `
              )
              .join("")}

          </div>
        </div>
        `;
      }

      if (window.location.href.includes("/junior/")) {
        this.resultsDiv.innerHTML = `
        
          <div class="one-full m-2">

            <h2 class="search-overlay__section-title">Gyakorlófeladatok</h2>
            ${results.gyakorlofeladatok.length ? "" : `<p>Nem találtunk ilyen feladatot.</p>`}
              ${results.gyakorlofeladatok
                .map(
                  (item) => `
                <div class="feladat-summary">
                  
                  <div class="event-summary__content">
                    <h5 class="feladat-summary__title headline headline--tiny">${item.title}</h5>
                    <p class="feladat-summary__content headline headline--tiny"></p>
                    ${
                      item.link
                        ? `<button class="btn-secondary bg-blue pill white mb-2"><a href="${item.link}" class="nu white">Feladatok</a></button>`
                        : ""
                    }
                        ${
                          item.link2
                            ? `<button class="btn-secondary bg-blue pill white mb-2"><a href="${item.link2}" class="nu white">Megoldások</a></button>`
                            : ""
                        }
                        ${
                          item.link3
                            ? `<button class="btn-secondary bg-blue pill white mb-2"><a href="${item.link3}" class="nu white">Hanganyag</a></button>`
                            : ""
                        }
                  </div>
                </div>
                
              `
                )
                .join("")}

          </div>

          
        </div>
        `;
      }

      this.isSpinnerVisible = false;
    } catch (e) {
      console.log(e);
    }
  }
}

export default SearchExam;
